import React from "react";
import { urlFor } from "../lib/client";

const HeroBanner = ({ heroBannerData }) => {
  return (
    <div className="hero-banner-container">
      <div className="left">
        <h1>{heroBannerData.largeText1}</h1>
        <p className="beats-solo">Hot 🔥: {heroBannerData.midText}</p>
      </div>
      <div className="desc">
        <img src={urlFor(heroBannerData.image)} alt="Cars" className="hero-banner-image" />
        <a href="https://discord.com/channels/784794493580476436/1022406330834755594">
          <button type="button">Pre Order Now!</button>
        </a>
      </div>
    </div>
  );
};

export default HeroBanner;
